/**
 * Props accepted by {@link TaskSendMessageIcon}.
 */
interface TaskSendMessageIconProps {
  className?: string;
  width?: number;
  height?: number;
}

/**
 * Renders the send icon used in the task conversation composer.
 *
 * @param props - Optional class name and dimensions for the icon.
 * @returns SVG send icon for the message action button.
 */
const TaskSendMessageIcon = ({
  className,
  width = 20,
  height = 20,
}: TaskSendMessageIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M8.75318 11.2501L17.5032 2.50014M8.8595 11.5235L11.0496 17.1552C11.2425 17.6513 11.339 17.8994 11.478 17.9718C11.5985 18.0346 11.742 18.0347 11.8626 17.972C12.0017 17.8998 12.0985 17.6518 12.292 17.1559L17.7839 3.08281C17.9586 2.63516 18.046 2.41133 17.9982 2.26831C17.9567 2.1441 17.8592 2.04663 17.735 2.00514C17.592 1.95736 17.3682 2.0447 16.9205 2.21939L2.8474 7.71134C2.3515 7.90486 2.10355 8.00163 2.03129 8.14071C1.96866 8.26129 1.96874 8.40483 2.03152 8.52533C2.10394 8.66433 2.352 8.7608 2.84812 8.95373L8.47979 11.1438C8.5805 11.183 8.63086 11.2026 8.67326 11.2328C8.71084 11.2596 8.7437 11.2925 8.77051 11.3301C8.80075 11.3725 8.82034 11.4228 8.8595 11.5235Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TaskSendMessageIcon;
